"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const photos = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599074/img/cavalier_puppy_lilac_blanket.png",
  alt: "Cavalier King Charles Spaniel puppy on a soft lilac blanket"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599074/img/blenheim_cavalier_pedigree_shot.png",
  alt: "Blenheim Cavalier puppy showing elegant pedigree features"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599074/img/tricolor_cavalier_upcoming_litter.png",
  alt: "Tricolor Cavalier puppy from an upcoming litter"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599074/img/cavalier_spaniel_royal_portrait.png",
  alt: "Royal portrait of a champion bloodline Cavalier puppy"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599074/img/cavalier_puppy_silver_background.png",
  alt: "Cavalier puppy posing against a silver aesthetic background"
}];
export default function MomentsWeveCaptured() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}